import React from 'react';
import { useTranslation } from 'react-i18next';
import { MultiSelect } from 'primereact/multiselect';
import { FormikProps } from 'formik';

import { DataSourceDto } from '../../../../../../../typescript-axios';
import { isFormFieldInvalid, getFormErrorMessage } from '../../../utils/form_utils';

interface StepSelectTablesProps {
    formik: FormikProps<{ dataSource: DataSourceDto }>;
    tableOptions: string[];
}

export const StepSelectTables: React.FC<StepSelectTablesProps> = ({ formik, tableOptions }) => {
    const { t } = useTranslation();

    return (
        <div className="field col-12">
            <label
                htmlFor="input-create-datasource-tables"
                className="font-medium"
            >
                {t('pages.dashboards.datasource.select_tables')}
                <span className="text-red-500 ml-1">*</span>
            </label>
            <MultiSelect
                id="input-create-datasource-tables"
                name="tables"
                value={formik.values.dataSource.query_definition.table_source}
                options={tableOptions}
                onChange={(e) =>
                    formik.setFieldValue(
                        'dataSource.query_definition.table_source',
                        e.value
                    )
                }
                onBlur={() =>
                    formik.setFieldTouched(
                        'dataSource.query_definition.table_source',
                        true
                    )
                }
                display="chip"
                filter
                className={
                    isFormFieldInvalid('dataSource.query_definition.table_source', formik.touched, formik.errors)
                        ? 'p-invalid'
                        : ''
                }
                style={{ width: '100%' }}
            />
            {isFormFieldInvalid('dataSource.query_definition.table_source', formik.touched, formik.errors) && (
                <small className="p-error block mt-1">
                    {getFormErrorMessage('dataSource.query_definition.table_source', formik.touched, formik.errors)}
                </small>
            )}
        </div>
    );
};